import {
	PdfAnnotationBorderStyle,
	PdfAnnotationSubtype,
	PdfSquareAnnoObject,
	Rect,
} from '@embedpdf/react-pdf-viewer';
import { restoreRect, transformRect, transformSize } from '@embedpdf/models';
import { Region, RegionSource } from 'components/file-editor-components/file-viewer/region-types';
import { PageGeometry } from 'components/file-editor-components/file-viewer/types';
import {
	REGION_APPEARANCE,
	REGION_FILL_COLOR,
	regionStrokeColor,
} from 'components/file-editor-components/file-viewer/regionAppearance';

export const percentToRect = (region: Region, page: PageGeometry): Rect => {
	const rotatedSize = transformSize(page.size, page.rotation, 1);
	const visualRect: Rect = {
		origin: {
			x: (region.x / 100) * rotatedSize.width,
			y: (region.y / 100) * rotatedSize.height,
		},
		size: {
			width: (region.width / 100) * rotatedSize.width,
			height: (region.height / 100) * rotatedSize.height,
		},
	};
	return restoreRect(rotatedSize, visualRect, page.rotation, 1);
};

export const rectToPercent = (rect: Rect, page: PageGeometry) => {
	const rotatedSize = transformSize(page.size, page.rotation, 1);
	const visualRect = transformRect(page.size, rect, page.rotation, 1);
	return {
		x: (visualRect.origin.x / rotatedSize.width) * 100,
		y: (visualRect.origin.y / rotatedSize.height) * 100,
		width: (visualRect.size.width / rotatedSize.width) * 100,
		height: (visualRect.size.height / rotatedSize.height) * 100,
	};
};

export const buildRegionFromAnnotation = (object: PdfSquareAnnoObject, page: PageGeometry): Region => ({
	id: object.id,
	sourceId: (object.custom?.sourceId as string) || object.id,
	pageIndex: object.pageIndex,
	...rectToPercent(object.rect, page),
	source: (object.custom?.source as RegionSource) || 'user',
});

export const buildSquareAnnotation = (region: Region, page: PageGeometry): PdfSquareAnnoObject => ({
	id: region.id,
	type: PdfAnnotationSubtype.SQUARE,
	pageIndex: region.pageIndex,
	rect: percentToRect(region, page),
	flags: ['print'],
	color: REGION_FILL_COLOR,
	...REGION_APPEARANCE,
	strokeColor: regionStrokeColor(region.source),
	strokeStyle: PdfAnnotationBorderStyle.SOLID,
	custom: { source: region.source, sourceId: region.sourceId },
});
